export const BRAND_COLORS = {
  fg: {
    brand: {
      default: '#1e417e',
      sub: '#9bb0e3',
    },
    neutral: {
      default: '#333',
      sub: '#636363',
      subtler: '#7e7e7e',
    },
  },
  bg: {
    brand: {
      default: '#eaf0fa',
    },
    neutral: {
      default: '#f1f1f1',
    },
  },
  border: {
    default: '#dadada',
  },
} as const
